/**
 *
 * Asynchronously loads the component for ListHeading
 *
 */

import { lazyLoad } from 'utils/loadable';

export const ListHeading = lazyLoad(
  () => import('./index'),
  module => module.ListHeading,
);
